<template>
  <div class="appointment-details-now">
    <div class="consult-message">
      <p class="pill-text mb-s Body2">Hi, {{ patientName }}!</p>
      <p>
        You are scheduled for
        <span class="purple-text">{{ typeOfConsultText }}</span>
        today
        <span class="purple-text"> at {{ this.appointment.clinicname }}</span>
      </p>
    </div>

    <countdown-timer class="mb-m"
                     :datetime="appointmentDateTime"
                     :queue-position="this.appointment.numpatients"
                     :virtual="isVirtualConsult"/>

    <!--    if virtual consult-->
    <div class="mb-m"
         v-if="isVirtualConsult">
      <div class="Body3 gray-400 mb-m">{{ countdownSubText }}</div>
      <!--      TODO: button not clickable yet-->
      <!-- <smd-btn section="4" variant="blue-enabled">
        Get Ready
      </smd-btn> -->
    </div>


    <!--    if onsite -->
    <div v-if="!isVirtualConsult">
      <!--    if onsite with time -->
      <p v-if="hasStartTime">
        Scheduled at <strong class="purple-text">{{ formattedOnsiteTime }}</strong>
      </p>
    </div>

    <p class="Hyperlink2 dodgerBlue"
       @click="goToMessage">
      Click here to message the doctor
    </p>
  </div>
</template>

<script>
  import CountdownTimer from '@/components/CountdownTimer';
  import moment from 'moment';
  import {
    CHAT_ROUTE,
    MESSAGE_DOCTOR_PARAM,
    MESSAGE_PATIENT_ID_PARAM,
  } from '@/router/routes';

  export default {
    name: "AppointmentDetailsNow",
    props: {
      appointment: {type: Object, required: false}
    },
    components: {CountdownTimer},
    computed: {
      appointmentDateTime() {
        return this.hasStartTime ? moment(this.appointment.starttime) : null;
      },
      hasStartTime() {
        return this.appointment.starttime !== null;
      },
      isVirtualConsult() {
        return this.appointment.virtualconsult;
      },
      typeOfConsultText() {
        return this.appointment.virtualconsult ? 'a Virtual Consult' : 'an Onsite Visit';
      },
      patientName() {
        return this.appointment.patient.name;
      },
      countdownSubText() {
        if (this.appointmentDateTime && this.appointment.numpatients) {
          return `There are ${this.appointment.numpatients} people ahead of you.`;
        }

        return 'Please standby for your turn.';
      },
      formattedOnsiteTime() {
        return moment(this.appointment.starttime).format('h:mm A');
      }
    },
    methods: {
      goToMessage() {
        this.$router.push({
          name: CHAT_ROUTE,
          params: {
            [MESSAGE_DOCTOR_PARAM]: this.appointment.doctor.usertag,
            [MESSAGE_PATIENT_ID_PARAM]: this.appointment.patient.id,
          },
        });
      },
    },
  }
</script>

<style lang="scss">
  .appointment-details-now {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    text-align: center;
    @include space-me($prop: margin, $all: s);

    .pill-text {
      @include border-radius(radius(pilled));
      background-color: color(gray-50);
      padding: space(xs) space(m);
    }

    .consult-message {
      @include space-me($prop: margin, $all: base);
      @extend %layout--flex-col-center-y;
    }
  }
</style>